import {
  combine,
  withMemo,
  withContext,
  withCallbacks,
} from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { StoreContext } from 'store/context'
import { withTableController } from 'shared/hooks'
import fp from 'lodash/fp'

import AccountComponent from './component'
import { createColumns } from './columns.description'

export default combine(
  withTableController({ id: 'inwins-table' }),
  withContext(
    'memberService',
    ServicesContext,
    ({ memberService }) => memberService
  ),
  withContext(
    'followerService',
    ServicesContext,
    ({ followerService }) => followerService
  ),
  withContext(
    'taxonomyService',
    ServicesContext,
    ({ taxonomyService }) => taxonomyService
  ),
  withContext('loggedEntity', StoreContext, fp.get('auth.loggedEntity')),

  withMemo('columns', ({ loggedEntity }) => createColumns(loggedEntity), []),

  withCallbacks(
    {
      loadBets:
        ({ memberService }) =>
        (tableState, _table, query) => {
          return memberService.queryInWins({
            page: tableState.page,
            size: tableState.pageSize,
            matchNameSearch: query?.search,
            tournamentId: query?.tournamentId,
            sportType: query?.sport,
            sort: 'date,desc',
          })
        },
      onSearch:
        ({ table }) =>
        (query) => {
          table.search(query)
        },
      loadBeneficiariesFromInwins:
        ({ memberService }) =>
        async (tableState) => {
          // Get all Inwins to extract distinct beneficiaries
          const inwinsResponse = await memberService.queryInWins({
            page: 0,
            size: 1000, // Get a large number to ensure we capture all beneficiaries
            sort: 'date,desc',
          })

          // Extract distinct beneficiaries from Inwins
          const beneficiariesMap = new Map()
          inwinsResponse.content.forEach((inwin) => {
            if (inwin.beneficiaryDTO?.id) {
              if (!beneficiariesMap.has(inwin.beneficiaryDTO.id)) {
                beneficiariesMap.set(
                  inwin.beneficiaryDTO.id,
                  inwin.beneficiaryDTO
                )
              }
            }
          })

          // Convert to array and apply pagination
          const allBeneficiaries = Array.from(beneficiariesMap.values())
          const startIndex = tableState.page * tableState.pageSize
          const endIndex = startIndex + tableState.pageSize
          const paginatedBeneficiaries = allBeneficiaries.slice(
            startIndex,
            endIndex
          )

          return {
            content: paginatedBeneficiaries,
            totalElements: allBeneficiaries.length,
            totalPages: Math.ceil(
              allBeneficiaries.length / tableState.pageSize
            ),
            size: tableState.pageSize,
            number: tableState.page,
          }
        },
      loadFavoriteBeneficiaries:
        ({ followerService }) =>
        async (tableState) =>
          await followerService.getBeneficiariesFollowers({
            page: tableState.page,
            size: tableState.pageSize,
          }),
      loadCategories:
        ({ taxonomyService }) =>
        async () =>
          await taxonomyService.queryBeneficiaryCategories(),
    },
    []
  )
)(AccountComponent)
